<script setup lang="ts">
type Props = {
  userCurrency: string;
  userCountry: string;
  userLanguage?: string;
  isBonusIcon?: boolean;
};

const { userCurrency, userCountry, isBonusIcon = false } = defineProps<Props>();
</script>

<template>
  <div
    v-if="userCountry && userCurrency"
    :class="$style.button"
  >
    <template v-if="isBonusIcon">
      <NuxtIcon
        :class="[$style.icon, $style.bonus]"
        name="koin"
      />
    </template>
    <template v-else>
      <NuxtIcon
        :class="$style.icon"
        :filled="true"
        :name="`flags/${userCountry}`"
      />
    </template>
    {{ userCurrency }}
  </div>
</template>

<style module lang="postcss">
.button {
  @apply w-full flex items-center justify-center gap-1.5 text-[.65rem] text-auth-text-inputs font-semibold uppercase;
  .icon {
    @apply text-xs rounded-full overflow-hidden;
    &.bonus {
      @apply text-primary text-xs;
    }
  }
}
</style>
